const {
  getContentValue
} = require('@truqc/content-path');
const {
  camelCase
} = require('lodash');

/**
  * @function evalute - evaluate objectArrayToOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  // this behavior's function is to pull out a specific
  // piece of data in an array of objects and return the set of that data
  // as a list of options.

  const objects = await sourceEvaluator(source.objects);
  const objectPath = await sourceEvaluator(source.objectPath);
  if (!objects || typeof objectPath !== 'string') {
    return undefined;
  }
  const valueSet = {};
  objects.forEach(object => {
    const value = getContentValue(objectPath, object);
    const option = {
      _created: value,
      title: `${value}`,
      identifier: `${camelCase(value)}`
    };
    valueSet[value] = option;
  });
  const result = Object.values(valueSet);
  return result;
};
module.exports = {
  evaluate
};